module.exports = __webpack_public_path__ + "img/11.0dde787a.png";